import { render } from "./AreaSelect.vue?vue&type=template&id=f206b540"
import script from "./AreaSelect.vue?vue&type=script&lang=js"
export * from "./AreaSelect.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__